import { Flex } from '@withjoy/joykit';
import React from 'react';
import { HotelTileList } from '../../components/Hotel';
import { HotelMap } from '../../components/Hotel/HotelMap';
import { useGuestEventHotelRoomBlocksQuery } from '@graphql/generated';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
interface Props {
  pageId: string;
  eventId: string;
  pageTitle?: string;
}

export const Custom: React.FC<Props> = ({ pageId, eventId, pageTitle }) => {
  const { data } = useGuestEventHotelRoomBlocksQuery({ variables: { eventId }, batchMode: 'fast' });
  const destination = data?.event?.hotelRoomBlocks?.destination;
  const reservedRoomBlocks = data?.event?.hotelRoomBlocks?.reservedRoomBlocks;

  const onSelectHotel = useEventCallback((id: string) => {
    const scrollEl = document.getElementById(id);
    if (scrollEl) {
      scrollEl.scrollIntoView({ behavior: 'smooth' });
    }
  });

  return (
    <Flex flexDirection={'column'} justifyContent={'center'} alignItems={'center'} width={'100%'}>
      {destination && reservedRoomBlocks && <HotelMap destination={destination} reservedRoomBlocks={reservedRoomBlocks} pageTitle={pageTitle} onSelectHotel={onSelectHotel} />}
      {reservedRoomBlocks && <HotelTileList hotelTileListData={reservedRoomBlocks} />}
    </Flex>
  );
};
